<div class="information-dialog">
  <div dialog-content>
    <div class="header">
      <div class="title">
        {{ title }}
      </div>

      <div class="rectangle"></div>

      <div class="close-button">
        <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-gray.svg" (click)="onClose()" />
      </div>

      <div class="column-container">
        <div class="first-column-title">{{ firstColumnTitle }}</div>
        <div class="second-column-title">{{ secondColumnTitle }}</div>
      </div>

      <div class="column-shadow"></div>
    </div>

    <div class="description-container">
      <div class="first-column-container">
        <div class="first-column" *ngFor="let obisId of firstColumn">
          {{ obisId }}
        </div>
      </div>
      <div class="second-column-container">
        <div class="second-column" *ngFor="let classification of secondColumn">
          {{ classification }}
        </div>
      </div>
    </div>
  </div>
</div>
